import { z } from 'zod';

const formLocation = window.RFI_CONFIG ? 'Inline' : 'Modal';
console.log('formLocation = ', formLocation);

function setNameValidationRules(label) {
	return z.string().superRefine((val, ctx) => {
		if (!val.trim()) {
			ctx.addIssue({
				code: z.ZodIssueCode.too_small,
				minimum: 1,
				type: 'string',
				inclusive: true,
				message: `${label} is required`,
			});
			return;
		}

		if (val.length < 2) {
			ctx.addIssue({
				code: z.ZodIssueCode.too_small,
				minimum: 2,
				type: 'string',
				inclusive: true,
				message: `Must have at least 2 characters`,
			});
		}

		if (!/^[A-Za-z'\-]+$/.test(val)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: `Cannot contain special characters`,
			});
		}
	});
}

function setPhoneNumberValidationRules() {
	return z.string().superRefine((val, ctx) => {
		if (!val.trim()) {
			ctx.addIssue({
				code: z.ZodIssueCode.too_small,
				minimum: 1,
				type: 'tel',
				inclusive: true,
				message: 'Phone number is required',
			});
			return;
		}

		if (!/^\(\d{3}\)\s\d{3}-\d{4}$/.test(val)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Must be ten digits long',
			});
		}
	});
}

function setZipCodeValidationRules() {
	return z.string().superRefine((val, ctx) => {
		if (!val.trim()) {
			ctx.addIssue({
				code: z.ZodIssueCode.too_small,
				minimum: 1,
				type: 'zipCode',
				inclusive: true,
				message: 'ZIP Code is required',
			});
			return;
		}

		if (!/^[0-9]{5}$/.test(val)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: 'Must be 5 digits long',
			});
		}
	});
}

function setEmailValidationRules() {
	return z.string().superRefine((val, ctx) => {
		const trimmed = val.trim();

		if (!trimmed) {
			ctx.addIssue({
				code: z.ZodIssueCode.too_small,
				minimum: 1,
				type: 'string',
				inclusive: true,
				message: 'Email Address is required',
			});
			return;
		}

		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

		if (!emailRegex.test(trimmed)) {
			ctx.addIssue({
				code: z.ZodIssueCode.custom,
				message: "Must include an '@' symbol and a top-level domain",
			});
		}
	});
}

export const modality = {
	id: `modality${formLocation}`,
	label: 'How would you like to learn?',
	type: 'radio', // changed from 'select' to 'radio'
	required: true,
	gf_input_name: 'input_24',
	value: '',
	options: [
		{ text: 'Online', value: 'online' },
		{ text: 'On-Campus', value: 'on-campus' },
	],
	validate: z.string().min(1, 'Modality is required'),
};

export const program = {
	id: `program${formLocation}`,
	label: 'Program',
	type: 'select',
	required: true,
	gf_input_name: 'input_25',
	value: '',
	placeholder: 'Select a Program',
	validate: z.string().min(1, 'Program is required'),
};

export const campusSpecializationDegreeLevel = {
	id: `campusSpecializationDegreeLevel${formLocation}`,
	label: 'Campus',
	type: 'select',
	required: true,
	gf_input_name: 'input_29',
	value: '',
	placeholder: 'Select a Campus',
	validate: z.string().min(1, 'is required'),
};

export const firstName = {
	id: `firstName${formLocation}`,
	class: 'first-name',
	label: 'First Name',
	type: 'text',
	required: true,
	gf_input_name: 'input_1.3',
	value: '',
	validate: setNameValidationRules('First Name'),
};

export const lastName = {
	id: `lastName${formLocation}`,
	class: 'last-name',
	label: 'Last Name',
	type: 'text',
	required: true,
	gf_input_name: 'input_1.6',
	value: '',
	validate: setNameValidationRules('Last Name'),
};

export const phoneNumber = {
	id: `phoneNumber${formLocation}`,
	class: 'phone-number',
	label: 'Phone Number',
	type: 'tel',
	required: true,
	gf_input_name: 'input_5',
	value: '',
	placeholder: '(800) 555-7890',
	validate: setPhoneNumberValidationRules(),
};

export const zipCode = {
	id: `zipCode${formLocation}`,
	class: 'zip-code',
	label: 'ZIP Code',
	type: 'zipCode',
	required: true,
	gf_input_name: 'input_27',
	value: '',
	validate: setZipCodeValidationRules(),
};

export const emailAddress = {
	id: `emailAddress${formLocation}`,
	class: 'email-address',
	label: 'Email Address',
	type: 'email',
	required: true,
	gf_input_name: 'input_2',
	value: '',
	validate: setEmailValidationRules(),
};

export const leadSource = {
	id: `leadSource${formLocation}`,
	class: 'lead-source',
	label: 'Lead Source',
	type: 'select',
	required: false,
	gf_input_name: 'input_37',
	value: '',
	placeholder: 'How did you hear about us?',
	options: [
		{ text: 'Internet / Social Media', value: 'INTINTWCUWEB' },
		{ text: 'Friend', value: 'REFER' },
		{ text: 'Alumni', value: 'ALUMNIWEB' },
		{ text: 'Community/School/Hospital Event', value: 'BDWEBDD' },
	],
	validate: z.string(),
};
